// extracted by mini-css-extract-plugin
export default {"wrapper":"divider_wrapper__xD2Ps","border":"divider_border__xffsf","text":"divider_text__NblTn"};